enum PermissionsEnum {
  NavigationDashboard = 'Navigation.Dashboard',
  NavigationProperties = 'Navigation.Properties',
  NavigationShowBlogPage = 'Navigation.ShowBlogPage',
  NavigationClients = 'Navigation.Clients',

  NavigationStores = 'Navigation.Agencies',

  NavigationTasks = 'Navigation.Tasks',

  NavigationSettings = 'Navigation.Settings',
  NavigationCategory = 'Navigation.Category',
  NavigationTopic = 'Navigation.Topic',
  NavigationBlog = 'Navigation.Blog',
  NavigationAdministrationMenu = 'Navigation.AdministrationMenu',
  NavigationHome = 'Navigation.Home',
  NavigationProfile = 'Navigation.Profile',
  NavigationSpecificationAttributes = 'Navigation.SpecificationAttributes',
  NavigationNews = 'Navigation.News',
  NavigationPointOfInterest = 'Navigation.PointOfInterest',
  NavigationNewsLetterSubscription = 'Navigation.NewsLetterSubscription',
  NavigationPointOfInterests = 'Navigation.PointOfInterests',
  NavigationPointOfInterestCategory = 'Navigation.PointOfInterestCategory',
  NavigationDocuments = 'Navigation.Documents',
  NavigationReporting = 'Navigation.Reporting',
  TopicsUpdate = 'Topics.Update',
  NewsUpdate = 'News.Update',
  BlogUpdate = 'Blog.Update',
  ProductUpdate = 'Product.Update',
  AccountSetting = 'Navigation.Settings',
  ProductInsert = 'Product.Insert',
  ProductAssigntoClient = 'Product.AssigntoClient',
  ProductClientRequest = 'Product.ClientRequest',
  ProductClone = 'Product.Clone',
  ProductAdminFilter = 'Product.AdminFilter',
  CategoryUpdate = 'Category.Update',
  MapAdd = 'Map.Add',

  CollectionShare = 'Collection.Share',
  ProductSelect = 'Product.Select',
  DocumentAdmin = 'Documents.Admin',
  POIFilter = 'Product.POIFilter',
}

export default PermissionsEnum;
